module.exports = __webpack_public_path__ + "static/media/allisonrietta-IG-2.71a89358.PNG";